<!--<div class="no_data_container">-->
<!--  <img *ngIf="showImage" [src]="path" alt="No Data" />-->
<!--  <p>-->
<!--    {{ msg }}-->
<!--  </p>-->
<!--</div>-->

<div class="no_data_container">
  <nz-empty
    [nzNotFoundImage]="path"
    [nzNotFoundContent]="msg"
  ></nz-empty>
</div>
